$(() => {
    const detailsList = $('.js-details-title');

    $(document).on('click', '.js-details-title', (e) => {
        const parent = $(e.target).closest('.js-details-wrap');

        if ($(parent).hasClass('is-open')) {
            $(parent).removeClass('is-open');

            return;
        }

        $('.js-details-title').closest('.js-details-wrap').removeClass('is-open');
        $(parent).addClass('is-open');
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/details.js